import React from 'react';
import PropTypes from 'prop-types';

const HeadLink = ({ rel, href, type = undefined, sizes = undefined }) => {
  return <link rel={rel} type={type} sizes={sizes} href={href} />;
};

HeadLink.propTypes = {
  rel: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  type: PropTypes.string,
  sizes: PropTypes.string,
};



export default HeadLink;
